import { motion } from 'framer-motion';
import { BrainCog, Rocket, LineChart, Command } from 'lucide-react';
import { FeatureCard } from './FeatureCard';

const features = [
  {
    icon: BrainCog,
    title: 'AI-Powered Strategy',
    description: 'Leverage advanced AI algorithms to develop data-driven business strategies tailored to your industry.'
  },
  {
    icon: Command,
    title: 'Operational Excellence',
    description: 'Optimize your business processes with AI-driven insights and automated efficiency tracking.'
  },
  {
    icon: Rocket,
    title: 'Growth Acceleration',
    description: 'Unlock exponential growth with AI-powered market analysis and expansion recommendations.'
  },
  {
    icon: LineChart,
    title: 'Real-Time Analytics',
    description: 'Monitor your business performance with live AI-enhanced dashboards and predictive analytics.'
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.5
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
      type: "spring",
      stiffness: 50,
      damping: 20,
      mass: 1
    }
  }
};

export const Features = () => {
  return (
    <section className="relative py-20 px-4 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.div
            variants={itemVariants}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text">
                Revolutionize Your Business
              </span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Harness the power of artificial intelligence to transform your business operations and accelerate growth.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                variants={itemVariants}
                custom={index}
              >
                <FeatureCard {...feature} />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};